import { useState } from 'react';
import {
  getManualAsset,
  getManualAssets,
  GetManulAssetsResult,
} from 'config/api';
import { ManualAssetType } from 'components/features/utils/manualAssetType';

type State = {
  manualAssets: {
    id: string;
    assetName: string;
    assetType: ManualAssetType;
    assetAmount: number;
  }[];
};

type useManulAssetProps = {
  state: State | null;
  loading: boolean;
  loaded: boolean;
};

function createState(
  getManualAssets: GetManulAssetsResult | null
): State | null {
  if (getManualAssets === null) {
    return null;
  }
  return {
    manualAssets: getManualAssets.Items.map(x => ({
      assetAmount: x.AssetAmount,
      assetName: x.AssetName,
      assetType: x.AssetType as ManualAssetType,
      id: x.ID,
    })),
  };
}

export function useManulAsset(): [
  useManulAssetProps,
  {
    callGetManualAsset: (id?: string) => Promise<State | null>;
  }
] {
  const [state, setState] = useState<GetManulAssetsResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  async function callGetManualAsset(id?: string): Promise<State | null> {
    setLoading(() => true);
    const data = await (async () => {
      if (id) {
        const getManualAssetData = await getManualAsset(id);
        return {
          Items: [getManualAssetData],
        };
      }
      return await getManualAssets();
    })();
    setState(data);
    setLoading(() => false);
    setLoaded(() => true);
    return createState(data);
  }

  const stateWrapper = {
    state: state === null ? null : createState(state),
    loading: loading,
    loaded: loaded,
  };

  return [stateWrapper, { callGetManualAsset }];
}
